import { DOCUMENT } from '@angular/common';
import { Component, DestroyRef, Inject, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TopbarComponent } from "./shared/components/topbar/topbar.component";
import { FooterComponent } from "./shared/components/footer/footer.component";
import { AnalysisStateService } from './shared/services/analysisState.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TopbarComponent, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'PaScal Viewer';
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private analysisStateService: AnalysisStateService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.analysisStateService.uploadedFileMetadata$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((file) => {
        this.document.title = file ? `${this.title} · ${file.fileName}` : this.title;
      });
  }
}
